import { ContainerAudit } from '../interfaces';
import { containersApiService } from '../../container/services/api';

export const fetchContainerAudits = async (companyId: number, containerId: number): Promise<ContainerAudit[]> => {
  const { movements } = await containersApiService.getContainerAuditReport(companyId, containerId);
  return movements.map((m: any) => ({
    containerCode: m.container_id,
    location: m.location_id, // Puedes mapear a nombre si tienes catálogo de ubicaciones
    user: m.user_name,
    date: new Date(m.date * 1000).toISOString(),
  }));
}; 